import { useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useAccountState } from 'contexts/account/account-context';
import { SnackbarActionTypes, useSnackbarDispatch } from 'contexts/snackbar/SnackbarContext';
import { usePost } from 'hooks/use-post';
import { useIntl } from 'react-intl';
import { ErrorMessage } from 'types/shared/error-message.type';
import { postOrder } from 'views/order-feed/features/my-supply-plan/api/orders-api';
import { CreateOrderInput, CreateOrderResult } from 'views/order-feed/features/my-supply-plan/types/create-order-input.type';
import { buildCreateOrderInput } from 'views/order-feed/features/my-supply-plan/utils/create-order-utils';

export const useCreateOrder = () => {
  const {
    account: { company },
  } = useAccountState();
  const snackbarDispatch = useSnackbarDispatch();
  const queryClient = useQueryClient();
  const intl = useIntl();

  const createOFDOrder = usePost<CreateOrderResult, { data: CreateOrderInput }, AxiosError<ErrorMessage[]>>(
    (request) => postOrder(company!.customerErpId, request.data),
    () => {
      snackbarDispatch({
        type: SnackbarActionTypes.SUCCESS_SNACKBAR,
        payload: { msg: intl.formatMessage({ id: 'snackbar.success.default' }) },
      });

      queryClient.invalidateQueries({ queryKey: ['getOrderAssortment'] });
    },
    (error) => {
      snackbarDispatch({
        type: SnackbarActionTypes.ERROR_SNACKBAR,
        payload: {
          msg: intl.formatMessage({ id: 'snackbar.errors.default' }),
          error: error,
          errorMsg: error.response?.data,
        },
      });
    }
  );

  return { buildOrderObject: buildCreateOrderInput, createOFDOrder };
};
